import Api from './ApiRequest';

export default  {
    insert: (entity, files) => Api.post('/cent/asset', entity, files),
    getAll: (params) => Api.get('/cent/assets', params),
    getById: (id) => Api.get(`/cent/asset/${id}`),
    getHistoryById: assetId => Api.get(`/cent/asset/${assetId}/history`),
    update: (id, entity, files) => Api.put(`/cent/asset/${id}`, entity, files),
    delete: (id) => Api.delete(`/cent/asset/${id}`),
    search: (searchText, params) => Api.get('/cent/assets/search', {q: searchText, ...params}),
    searchContents: (searchText, params) => Api.get('/cent/assets/searchcontents', {q: searchText, ...params}),
    getAssetTypes: (params) => Api.get('/cent/asset/types', params),
    getStats: () => Api.get('/cent/assets/stats'),
};
